// extracted by mini-css-extract-plugin
export default {"rating":"TH-z","numberOfStars":"UH-z","count":"VH-z","barGraphSpacing":"WH-z","barGraph":"XH-z"};